import { Box, Typography, Link } from '@mui/material';
import FeedIcon from '@mui/icons-material/Feed';
import DashboardCard from '../common/DashboardCard';

function News(props: any) {
    const accentColor = props.accentColor;
    return (
        <DashboardCard
            title="News (Coming Soon)"
            icon={<FeedIcon />}
            accentColor={accentColor}
        >
            <Box sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ mr: 2 }}>
                        05/12/2022
                    </Typography>
                    <Link href="#" underline="hover">
                        News headline text.
                    </Link>
                </Box>
            </Box>
        </DashboardCard>
    );
}

export default News;
